import { createContext, useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
// utils
import axios from '../utils/axios';
import { isValidToken, setSession } from '../utils/jwt';

// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  cargo: null,
  timeRes: null,
};

const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user, cargo, timeRes } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
      cargo, 
      timeRes
    };
  },
  LOGIN: (state, action) => {
    const { user, cargo, timeRes } = action.payload;
    console.log("up")
    console.log(user)  
    return {
      ...state,
      isAuthenticated: true,
      user,
      cargo,
      timeRes
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
    cargo: null, 
    timeRes: null
  }),
  REGISTER: (state, action) => {
    const { user, cargo } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
      cargo
    };
  },
  
  CHANGECARGO: (state, action)=>{
    const {cargo}= action.payload;

    return {
      ... state,
      cargo
    }
  }
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  changecargo: () => Promise.resolve()
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        console.log(accessToken)
        if (accessToken && isValidToken(accessToken)) {
          
          const expiration = setSession(accessToken); 
          console.log("expiration", expiration)
          // qyue hay algo rato en esta consulta 
          const response = await axios.get('/api/users/user/profile');
          
          const user  = response.data;
          console.log("estoy aquuiii")
          console.log(user)
          console.log("estoy yaa")
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: true,
              user,
              cargo: user.departamento.usuario_en[0]?.length > 0 ? user.departamento.usuario_en[0] : user.departamento.jefaturas[0],
              timeRes: expiration
            },
          });
        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
              cargo: null,
              timeRes: null
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
            cargo: null,
            timeRes: null
          },
        });
      }
    };

    initialize();
  }, []);

  const login = async (username, password) => {
    const response = await axios.post('/api/auth/singin', {
      username,
      password,
    });
    const { token, user } = response.data;
    console.log (user);
    const expiration = setSession(token);
    dispatch({
      type: 'LOGIN',
      payload: {
        user,
        cargo: user.departamento.usuario_en[0]?.length > 0 ? user.departamento.usuario_en[0] : user.departamento.jefaturas[0],
        timeRes: expiration
      },
    });
  };

  const register = async (email, password, firstName, lastName) => {
    const response = await axios.post('/api/account/register', {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem('accessToken', accessToken);
    dispatch({
      type: 'REGISTER',
      payload: {
        user,
      },
    });
  };

  const logout = async () => {
    setSession(null);
    dispatch({ type: 'LOGOUT' });
  };

  const changecargo = async(cargo) => {
    dispatch({ 
      type: 'CHANGECARGO',
      payload: {
        cargo
      }   
    })
  }

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        register,
        changecargo
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
